var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as MobileDetect from 'mobile-detect/mobile-detect';
import { includes } from 'lodash';
import { matchPath } from 'react-router-dom';
var md = new MobileDetect(window.navigator.userAgent);
var isMobile = md.mobile();
var defaultProps = {
    className: '',
    enable: true,
    option: {
        wheelPropagation: true,
    },
    containerRef: function () { },
    onScrollY: undefined,
    onScrollX: undefined,
    onScrollUp: undefined,
    onScrollDown: undefined,
    onScrollLeft: undefined,
    onScrollRight: undefined,
    onYReachStart: undefined,
    onYReachEnd: undefined,
    onXReachStart: undefined,
    onXReachEnd: undefined,
};
var handlerNameByEvent = {
    'ps-scroll-y': 'onScrollY',
    'ps-scroll-x': 'onScrollX',
    'ps-scroll-up': 'onScrollUp',
    'ps-scroll-down': 'onScrollDown',
    'ps-scroll-left': 'onScrollLeft',
    'ps-scroll-right': 'onScrollRight',
    'ps-y-reach-start': 'onYReachStart',
    'ps-y-reach-end': 'onYReachEnd',
    'ps-x-reach-start': 'onXReachStart',
    'ps-x-reach-end': 'onXReachEnd',
};
Object.freeze(handlerNameByEvent);
var styles = function (theme) { return ({
    root: {},
}); };
// @ts-ignore
var Scrollbars = /** @class */ (function (_super) {
    __extends(Scrollbars, _super);
    function Scrollbars(props) {
        var _this = _super.call(this, props) || this;
        _this.updatePs = function () {
            if (!_this._ps) {
                return;
            }
            _this._ps.update();
        };
        _this.destroyPs = function () {
            if (!_this._ps) {
                return;
            }
            // unhook up evens
            Object.keys(_this._handlerByEvent).forEach(function (value, key) {
                // @ts-ignore
                _this._container.removeEventListener(key, value, false);
            });
            _this._handlerByEvent.clear();
            _this._ps.destroy();
            _this._ps = null;
        };
        _this.createPs = function () {
            if (isMobile || !_this._container || _this._ps) {
                return;
            }
            _this._ps = new PerfectScrollbar(_this._container, _this.props.option);
            // hook up events
            Object.keys(handlerNameByEvent).forEach(function (key) {
                var callback = _this.props[handlerNameByEvent[key]];
                if (callback) {
                    var handler = function () { return callback(_this._container); };
                    _this._handlerByEvent.set(key, handler);
                    _this._container.addEventListener(key, handler, false);
                }
            });
        };
        _this.handleRef = function (ref) {
            _this._container = ref;
            _this.props.containerRef(ref);
        };
        _this._handlerByEvent = new Map();
        return _this;
    }
    Scrollbars.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (this.props.customScrollbars) {
            setTimeout(function () {
                _this.createPs();
            });
        }
        else {
            setTimeout(function () {
                _this.destroyPs();
            });
        }
        this.updatePs();
    };
    Scrollbars.prototype.componentDidMount = function () {
        this.createPs();
    };
    Scrollbars.prototype.componentWillUnmount = function () {
        this.destroyPs();
    };
    Scrollbars.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, customScrollbars = _a.customScrollbars, enable = _a.enable;
        var isChannelHome = !!matchPath(this.props.location.pathname, {
            path: ['/channel/:id/home'],
            exact: true,
            strict: false,
        });
        var isScrollDisabled = includes(['/home', '/subscriptions'], this.props.location.pathname) || isChannelHome;
        return customScrollbars && enable && !isMobile ? (React.createElement("div", { id: "scrollbar-wrapper", className: className, style: {
                position: 'relative',
                height: '100%',
                overflow: isScrollDisabled ? 'none !important' : 'overlay',
            }, ref: this.handleRef }, children)) : (React.createElement("div", { id: "track-list-container", className: this.props.className, style: {
                overflow: isScrollDisabled ? 'none !important' : 'overlay !important',
            } }, this.props.children));
    };
    Scrollbars.defaultProps = defaultProps;
    Scrollbars = __decorate([
        withStyles(styles, { withTheme: true })
    ], Scrollbars);
    return Scrollbars;
}(React.PureComponent));
function mapStateToProps(_a) {
    var fuse = _a.fuse;
    return {
        customScrollbars: fuse.settings.current.customScrollbars,
    };
}
export default withRouter(connect(mapStateToProps)(Scrollbars));



//////////////////
// WEBPACK FOOTER
// ./src/theme/components/Scrollbars.tsx
// module id = 419
// module chunks = 81